<template lang="html">
  <v-btn
    class="py-0 pl-3 pr-3 pl-sm-4 pr-sm-4 custom-btn-outlined btn-filter"
    @click="handleClick"
    :class="{'padding-right-btn-filter': !isItTablet && showBadgeOfSelectedFilters}"
    :style="increaseHeight ? 'height: 48px !important' : ''"
  >
    <div class="txt-filter">
      {{ $t('general.filter.title') }}
    </div>
    <v-badge
      v-show="showBadgeOfSelectedFilters"
      class="ml-1"
      offset-x="40px"
      color="primary"
      :content="numberOfSelectedFilters"
      inline
    />
  </v-btn>
</template>

<script>
export default {
  props: {
    showBadgeOfSelectedFilters: {
      type: Boolean,
      default: false,
    },
    numberOfSelectedFilters: {
      type: Number,
      default: null,
    },
    isItTablet: {
      type: Boolean,
      default: false,
    },
    increaseHeight: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick($e) {
      this.$emit('click:' + 'filterPanel', $e);
    }
  },
};
</script>

<style lang="css" scoped>
.btn-filter {
  height: 44px !important;
  justify-content: left;
  border-radius: 6px !important;
  border-color: #B3B3B3 !important;
}

.padding-right-btn-filter {
  padding-right: 4px !important;
}
</style>
<style lang="scss" scoped>
.txt-filter {
  @include text-value-color;
  font-weight: 400;
  letter-spacing: 0px;
  font-size: 16px;
}
</style>